import { render, staticRenderFns } from "./AdditionalInformationTab.vue?vue&type=template&id=48f65fb4"
import script from "./AdditionalInformationTab.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports